//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import TopoTitleComponente from '../../../components/PageTitle/TopoTitleComponente';
import ListagemPage from '../../../components/templates/ListagemPage';
import TopoListagem from '../../../components/Topo/TopoListagem';
import { objectsConstants } from '../../../_constants/objects.constants';
import { tableHelper } from '../../../_helpers/tableHelper';
import { entradaEstoqueService } from '../../../_services/entradaEstoque.service';
import EstoqueEntradaListFilter from './EstoqueEntradaListFilter';

const columns = [
  {
    path: 'type',
    pathFilter: 'type',
    title: 'Tipo',
    isKey: false,
    isTipoNota: true,
    dataSort: true,
    className: 'nomeProprio column-bold',
    width: '10%',
  },
  {
    path: 'tipoEntrada',
    pathFilter: 'tipoEntrada',
    title: 'Tipo de entrada',
    isKey: false,
    isTipoEntrada: true,
    dataSort: true,
    className: '',
    width: '10%',
  },
  {
    path: 'dataHoraLancamento',
    pathFilter: 'dataHoraLancamento',
    title: 'Data do lancamento',
    isKey: false,
    dataSort: true,
    isDateTime: true,
    className: 'nomeProprio column-bold',
    width: '10%',
  },

  {
    path: 'numeroNotaFiscal',
    pathFilter: 'numeroNotaFiscal',
    title: 'Nº Nota fiscal',
    isKey: true,
    dataSort: true,
    width: '23%',
  },
  {
    path: 'responsavel.nome',
    pathFilter: 'responsavel.nome',
    title: 'Nome do usuário',
    isKey: false,
    dataSort: true,
    // isAvatar: true,
    propsMidiaId: 'foto.id',
    // className: 'avatar-list',
    width: '22%',
  },
  {
    path: 'justificativa',
    pathFilter: 'justificativa',
    title: 'justificativa',
    isKey: false,
    dataSort: true,
    width: '25%',
  },
  {
    path: 'situacao',
    pathFilter: 'situacao',
    title: 'Situação',
    isKey: false,
    dataSort: true,
    className: 'nomeProprio column-bold',
    width: '10%',
  },
];

const endPoint = '/estoque-entrada/novo';
const endPointView = '/estoque-entrada/view/';
class EstoqueEntradaListagemPage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);
    let fields = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );
    let labels = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    this.props.history.push(endPointView + row.id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
    // this.props.history.push({
    //   pathname: endPoint,
    //   state: {
    //     titlePage: 'Usuário',
    //   },
    // });
  };

  render() {
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_ESTOQUE_ENTRADA}
          subTitle=" "
          canBack={false}
        />
        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.CRUD_ESTOQUE_EDITAR}
          buttonActionClassName={'btn-light'}
          buttonAction={() => {
            this.handleNewButton();
          }}
          securityActionIcon={'icon-btn-add'}
          securityActionName={'Nova entrada'}
        ></TopoListagem>
        <ListagemPage
          title={'Estoque: Entradas'}
          showNewButton={false}
          delete={() => {}}
          service={entradaEstoqueService}
          defaultOrder={'dataHoraLancamento'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={EstoqueEntradaListFilter}
          controller="api/entradaEstoque"
          fields={this.state.fields}
          labels={this.state.labels}
          columns={columns}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(EstoqueEntradaListagemPage);
